<template>
    <div class="content">
        <div class="title">
            <Header @changeSite="changeSite" />
        </div>
        <Box width="1600" height="864" title="通讯状态">
            <div class="body" id="communicationstatus">
                <div class="query">
                    <div class="query-left">
                        <el-select v-model="deviceName" placeholder="全部设备">
                            <el-option v-for="item in devices" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-model="statusName" placeholder="全部状态">
                            <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <input type="text" placeholder="请输入设备名称" v-model="deviceFilterText">
                    </div>

                    <div class="query-right">
                        <div class="dataContainer">
                            <div class="title">在线总数: </div>
                            <div class="data">{{ onlineNum }}</div>
                        </div>
                        <div class="dataContainer">
                            <div class="title">离线总数: </div>
                            <div class="data">{{ deviceNum - onlineNum }}</div>
                        </div>
                    </div>

                </div>

                <el-table v-if="currentTableData.length > 0" :data="currentTableData" border stripe
                    style="width:81vw;margin-top:25px" height="250">
                    <el-table-column prop="device_name" align="center" resizable label="设备名称">
                    </el-table-column>
                    <el-table-column prop="name" align="center" label="设备类型">
                    </el-table-column>
                    <el-table-column prop="position" align="center" label="位置">
                    </el-table-column>

                    <el-table-column prop="onlineImg" align="center" label="通讯状态">
                        <template slot-scope="scope">
                            <img :src="scope.row.onlineImg ? scope.row.onlineImg : require('@/assets/img/离线.png')"
                                alt="" style="width:32px; height:24px">
                        </template>
                    </el-table-column>
                </el-table>
                <div v-else class="row-center tip">
                    <img v-if="!loading" src="../../../assets/img/not_found_data.png" alt="">
                    <img v-else src="@/assets/img/loading.png" alt="" class="loading">
                </div>
            </div>
        </Box>
    </div>
</template>

<script>
    import Header from "../Header";
    import Box from "../Box";
    import {
        GET_AREAS,
        GetEboxAndMonitor,
        GetMinitorState,
    } from "../../../api/common"
    export default {
        name: "CommunicationStatus",
        components: {
            Header,
            Box,
        },
        data() {
            return {
                areaId: -1,
                loading: false,
                influxDbName: '',
                deviceName: "全部设备",
                statusName: "全部状态",
                deviceFilterText: "",
                devices: [{
                    value: '全部设备',
                    label: '全部设备'
                }, {
                    value: '网关设备',
                    label: '网关设备'
                }, {
                    value: '安防设备',
                    label: '安防设备'
                }],
                status: [{
                    value: '全部状态',
                    label: '全部状态'
                }, {
                    value: '在线',
                    label: '在线'
                }, {
                    value: '离线',
                    label: '离线'
                }],
                deviceNum: 0,
                onlineNum: 0,
                eBoxInfos: [],
                allData: [],
                monitorStatus: [],
            }
        },
        created() {
            GET_AREAS().then(res => {
                this.areaId = res.data.data.areas[0].areaId
                this.getEboxandMonitor()
            })
        },
        computed: {
            tableData() {
                let allData = this.allData
                let onlineNum = 0
                allData.forEach((item, index) => {
                    if (item.device_category_id == 3) {
                        let currentEboxDetail = this.$store.getters.eBoxInfo().find(value =>
                            JSON.parse(item.device_details)['设备地址'].code == value.deviceId &&
                            value.projectName == this.$store.state.project.projectInfo.influxDbName)
                        if (currentEboxDetail && currentEboxDetail.online == true) {
                            this.$set(allData[index], 'online', 'true')
                            this.$set(allData[index], 'onlineImg', require('@/assets/img/在线.png'))
                            onlineNum++
                        } else {
                            this.$set(allData[index], 'online', 'false')
                            this.$set(allData[index], 'onlineImg', require('@/assets/img/离线.png'))
                        }
                    } else if (item.device_category_id == 2) {
                        let currentMonitorDetail = this.$store.getters.eBoxInfo().find(value =>
                            JSON.parse(item.device_details)['cameraId'] == value.deviceId && value
                            .projectName == this.$store.state.project.projectInfo.influxDbName)
                        if (currentMonitorDetail && currentMonitorDetail.online) {
                            this.$set(allData[index], 'online', 'true')
                            this.$set(allData[index], 'onlineImg', require('@/assets/img/在线.png'))
                            onlineNum++
                        } else {
                            this.$set(allData[index], 'online', 'false')
                            this.$set(allData[index], 'onlineImg', require('@/assets/img/离线.png'))
                        }
                    }
                })
                this.onlineNum = onlineNum
                return allData
            },
            currentTableData() {
                let name = this.deviceName == '全部设备' ? '' : this.deviceName
                let status = this.statusName == '全部状态' ? '' : this.statusName == '在线' ? 'true' : 'false'
                return this.tableData.filter(item => (item.device_name.includes(this.deviceFilterText) && item.name
                    .includes(name) && item.online.includes(status)))
            }
        },
        mounted() {},
        methods: {
            getMonitorStatus() {
                GetMinitorState().then(res => {
                    this.monitorStatus = res.data.data.res.callback
                })
            },
            getEboxandMonitor() {
                GetEboxAndMonitor(this.areaId).then(res => {
                    this.allData = res.data.data.devices.filter(item => item.device_type_name != '门禁')
                    this.deviceNum = this.allData.length
                    this.allData.forEach((item, index) => {
                        if (item.device_category_id == 2) {
                            this.allData[index]['position'] = JSON.parse(item.device_details).position
                        } else {
                            this.allData[index]['position'] = JSON.parse(item.device_details)['设备地址']
                                .position
                        }
                    })
                    // this.getMonitorStatus()
                })
            },
            changeSite(value) {
                this.areaId = value
                this.deviceName = '全部设备'
                this.statusName = '全部状态'
                this.deviceFilterText = ''

                this.getEboxandMonitor()
            },
        }
    };
</script>

<style lang="less" scoped>
    .content {
        .w(1600);
        .h(968);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .body {
        width: 97%;
        .h(764);
        margin-top: 250/108vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .query {
            width: 100%;
            height: 40px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .query-left {
                .w(832);
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .el-select {
                    .w(260);
                    height: 40px;
                    margin-right: 80/192vw;
                }

                .el-input {
                    .w(280);
                    height: 40px;
                    border-radius: 4px;
                    // border: 1px solid rgba(0, 0, 0, 0.15);
                    // padding-left: 150/192vw;
                    margin-right: 160/192vw;
                }

                input {
                    .w(280);
                    height: 40px;
                    border-radius: 4px;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    padding-left: 150/192vw;
                    margin-right: 160/192vw;
                }

                .btn {
                    .w(96);
                    height: 40px;
                    border-radius: 4px;
                    background: rgba(13, 148, 255, 1);
                    font-size: 18rem;
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                }
            }

            .query-right {
                .w(300);
                height: 40px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                .dataContainer {
                    height: 40px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;

                    .title {
                        font-size: 18rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    .data {
                        font-size: 18rem;
                        font-weight: bold;
                        color: #0D94FF;
                        margin-left: 100/192vw;
                    }
                }
            }
        }
    }

    .tip {
        width: 100%;
        height: 100%;
        font-size: 16rem;
        color: #8c939d;
    }

    .loading {
        width: 28rem;
        height: 28rem;
        animation: loading 1s linear infinite;
    }

    @keyframes loading {
        0% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>